module.exports = __webpack_public_path__ + "img/index-img3.b6397bd0.png";